import { FlowioThunkCreator } from "../types";

import * as AC from "./actionCreators";
import * as R from "../../requests/feedback/requestCreators";
import { getBugReportSlice } from "./selectors";
import flowioast from "../../utils/flowioast";

type Params = {
  files: File[];
};

// BUG REPORT
type BugReportThunkCreator = FlowioThunkCreator<Params>;

export const submitBugReport: BugReportThunkCreator =
  ({ files }) =>
  (dispatch, getState) =>
    Promise.resolve().then(async () => {
      const bugReportSlice = getBugReportSlice(getState());
      const { errorStack, lastInvocation, message } = bugReportSlice;

      const payloadMsg = JSON.stringify({
        errorStack,
        lastInvocation,
        message,
      });

      dispatch(AC.submitBugRequest());

      await R.submitBugReport(payloadMsg, files)
        .then(() => {
          dispatch(AC.submitBugSuccess());
          flowioast.success.fromIntlBase("feedback.bug_report.submit.singular");
        })
        .catch((e) => {
          dispatch(AC.submitBugError());
          flowioast.error.fromIntlBase(
            "feedback.bug_report.submit.singular",
            e
          );
        });
    });

export type SubmitBugReport = BugReportThunkCreator;
